import React from "react";

const STATUS_COLORS: Record<string, string> = {
  RUNNING: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  DOWN: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  UNDER_MAINTENANCE: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  IDLE: "bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-300",
  RETIRED: "bg-slate-200 text-slate-500 dark:bg-slate-800 dark:text-slate-500",
  CRITICAL: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  HIGH: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300",
  MEDIUM: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  LOW: "bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-300",
  OPEN: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  ASSIGNED: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300",
  IN_PROGRESS: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  COMPLETED: "bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300",
  VERIFIED: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300",
  CLOSED: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  CANCELLED: "bg-slate-200 text-slate-500 dark:bg-slate-800 dark:text-slate-500",
};

export const Badge: React.FC<{ value: string; label?: string }> = ({ value, label }) => (
  <span className={`badge ${STATUS_COLORS[value] ?? "bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200"}`}>
    {label ?? value.replace(/_/g, " ")}
  </span>
);
